import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ArrowRight } from "lucide-react";
 * // Use <ArrowRight /> instead
 */
export const ArrowRightIcon = createSVGWrapper(
  <path
    fill="currentColor"
    d="M12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L13.7071 19.7071C13.3166 20.0976 12.6834 20.0976 12.2929 19.7071C11.9024 19.3166 11.9024 18.6834 12.2929 18.2929L17.5858 13H5C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11H17.5858L12.2929 5.70711Z"
  />
);
